import { useQuery } from '@apollo/client';

import MEMBERSHIP_PRICES_QUERY from '../graphql/DialogGetPhoneMembershipPrices.graphql';
import type { DialogGetPhoneMembershipPrices } from '../graphql/types/DialogGetPhoneMembershipPrices';
import type { Prices } from '../types';

function useMembershipPrices(): Prices | undefined {
  const { data } = useQuery<DialogGetPhoneMembershipPrices>(
    MEMBERSHIP_PRICES_QUERY,
  );

  let prices: Prices | undefined;

  if (data?.membershipTypesV2?.edges.length) {
    const priceRes = data.membershipTypesV2.edges[0]?.node?.prices;

    prices = {
      total: String(priceRes?.total) || '',
      currencySymbol: priceRes?.currencySymbol || '',
    };
  }

  return prices;
}

export default useMembershipPrices;
